import { useMemo } from 'react'

import dynamicRepo from '@/repository/dynamicRepo'
import type { ClassT } from '@/types'

const useDynamicRepo = <T extends ClassT>(
  [service, key]: [service: T, key: string],
  ...param: ConstructorParameters<T>
) => useMemo(() => dynamicRepo.reg([service, key], ...param), [key])

export default useDynamicRepo
